import { ShiftSchedule } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ShiftSchedule";
import { SimpleHeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/SimpleHeadedContainerSticky";
import { Text } from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import { css } from "styled-components";

const SimpleSharedGridStyleNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 6px;
`;

interface SkiftplanPanelProps {
  vehicle: AlternativeTransportVehicle;
}

export const SkiftplanPanel = ({ vehicle }: SkiftplanPanelProps) => (
  <SimpleHeadedContainerSticky
    panelStyle={SimpleSharedGridStyleNoPadding}
    headerHeight="54px"
    variant="main"
    headingLeft={<Text>Skiftplan</Text>}
  >
    <ShiftSchedule vehicle={vehicle} />
  </SimpleHeadedContainerSticky>
);
